import {Component, ElementRef, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {RestService} from "../shared/rest/rest.service";
import {AlertService} from "../shared/alert.service";
import {AnimationUtil} from "../shared/material/animation-util";
import {Router} from "@angular/router";

@Component({
  selector: 'app-code',
  templateUrl: './code.component.html',
  styleUrls: ['./code.component.scss'],
  animations: [
    AnimationUtil.submitButtonAnimation
  ]
})
export class CodeComponent  {

  inProgress = false;
  success = false;


  codeForm = new FormGroup({
    code: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)])
  });

  constructor(  private router: Router,
                private alertService: AlertService,
                public restService: RestService) {
  }



  code() {
    if (!this.inProgress) {
      this.inProgress = true;
      this.restService.code(
        this.codeForm.value.code
      ).subscribe(response => {
          this.success = true;
          setTimeout(() => {
            window.location.href = response.url;
          }, 300)
        }, error => {
          this.markFailure(error)
        });
    }
  }
  private markFailure(error?: any) {
    console.warn("there is an error! Check logs!", error);
    this.alertService.error('code.error');
    this.inProgress = false;
    this.success = false;
  }

  @ViewChild('logoutSubmitCode') logoutSubmit: ElementRef;

  logout() {
    this.logoutSubmit.nativeElement.submit();
    this.router.navigate(['/boslogin']);
  }


}
